import React from 'react';
import { Button, Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PhoneIcon from '@material-ui/icons/Phone';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import siteConfig from '../siteConfig';
import { colors } from '../theme';

const useStyles = makeStyles((theme) => ({
  hero: {
    position: 'relative',
    minHeight: '92vh',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    color: '#FFFFFF',
    // A navy shade on top of a navy-to-green gradient.
    background: [
      'linear-gradient(100deg, rgba(14,35,64,0.88) 0%, rgba(14,35,64,0.65) 50%, rgba(14,35,64,0.35) 100%)',
      `linear-gradient(135deg, ${colors.navy} 0%, ${colors.greenDark} 100%)`,
    ].join(', '),
    [theme.breakpoints.down('xs')]: {
      minHeight: '88vh',
    },
  },
  content: {
    position: 'relative',
    paddingTop: theme.spacing(14),
    paddingBottom: theme.spacing(10),
  },
  inner: {
    maxWidth: 680,
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '6px 14px',
    borderRadius: 999,
    backgroundColor: 'rgba(227,178,60,0.18)',
    border: '1px solid rgba(227,178,60,0.5)',
    color: colors.gold,
    fontWeight: 600,
    fontSize: 14,
    marginBottom: theme.spacing(3),
  },
  title: {
    fontSize: '3.6rem',
    [theme.breakpoints.down('sm')]: { fontSize: '2.8rem' },
    [theme.breakpoints.down('xs')]: { fontSize: '2.2rem' },
  },
  highlight: {
    color: colors.gold,
  },
  subtitle: {
    marginTop: theme.spacing(3),
    fontSize: '1.2rem',
    color: 'rgba(255,255,255,0.88)',
    maxWidth: 560,
    [theme.breakpoints.down('xs')]: { fontSize: '1.05rem' },
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginTop: theme.spacing(5),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      '& > *': { width: '100%' },
    },
  },
  outlineButton: {
    color: '#FFFFFF',
    borderColor: 'rgba(255,255,255,0.7)',
    '&:hover': {
      borderColor: '#FFFFFF',
      backgroundColor: 'rgba(255,255,255,0.08)',
    },
  },
}));

export default function Hero() {
  const classes = useStyles();

  return (
    <header id="top" className={classes.hero}>
      <Container maxWidth="lg" className={classes.content}>
        <div className={classes.inner}>
          <span className={classes.badge}>
            <CheckCircleIcon style={{ fontSize: 18 }} /> Free estimates · Call or text any time
          </span>
          <Typography variant="h1" className={classes.title}>
            Landscaping, lawn care &amp; <span className={classes.highlight}>pressure washing</span> done right.
          </Typography>
          <Typography className={classes.subtitle}>
            {siteConfig.businessName} keeps your yard healthy and your decks, driveways and
            sidewalks spotless — at prices that make sense
            {siteConfig.serviceArea ? ` for homeowners across ${siteConfig.serviceArea}` : ''}.
          </Typography>
          <div className={classes.actions}>
            <Button variant="contained" color="secondary" size="large" href="#contact">
              Get a free estimate
            </Button>
            <Button
              variant="outlined"
              size="large"
              href={siteConfig.phoneHref}
              startIcon={<PhoneIcon />}
              className={classes.outlineButton}
            >
              Call {siteConfig.phoneDisplay}
            </Button>
          </div>
        </div>
      </Container>
    </header>
  );
}
